import { HTMLAttributes } from 'react';
import { LucideIcon } from 'lucide-react';

export interface StatCardProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  value: string | number;
  icon?: LucideIcon;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  description?: string;
}

export function StatCard({
  title,
  value,
  icon: Icon,
  trend,
  description,
  className = '',
  ...props
}: StatCardProps) {
  return (
    <div
      className={`rounded-2xl border border-admin-border bg-white p-6 shadow-sm transition-all hover:shadow-md ${className}`}
      {...props}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-admin-muted">{title}</p>
          <p className="mt-2 text-3xl font-bold text-admin-ink">{value}</p>
          
          {trend && (
            <div className="mt-2 flex items-center gap-1">
              <span
                className={`text-sm font-semibold ${
                  trend.isPositive ? 'text-green-600' : 'text-red-600'
                }`}
              >
                {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value)}%
              </span>
              <span className="text-xs text-admin-muted">前月比</span>
            </div>
          )}
          
          {description && (
            <p className="mt-2 text-xs text-admin-muted">{description}</p>
          )}
        </div>
        
        {Icon && (
          <div className="rounded-xl bg-admin-accent/10 p-3">
            <Icon className="h-6 w-6 text-admin-accent" />
          </div>
        )}
      </div>
    </div>
  );
}
